/**
* Project janux-vuejs-seed
* Created by hielo on 2018-05-10
*/

<template lang="pug">
	div

		fieldset

			.field-title(v-if="data.name.first") First Name *
			.error-val.error-contact(v-if="!data.name.first") Enter a valid name *
			.each-field-contact: b-form-input.all-fields(placeholder='First Name' v-model='data.name.first', required="", @input="validate", :class="{ errorInField: !data.name.first }")

		fieldset

			.field-title(v-if="data.name.last") Last Name *
			.error-val.error-contact(v-if="!data.name.last") Enter a valid last name *
			.each-field-contact: b-form-input.all-fields(placeholder='Last Name' v-model='data.name.last', required="", @input="validate", :class="{errorInField: !data.name.last}")

		// slot(:person-name-valid="isValid")
</template>

<script>
export default {
	name: 'jnx-person-name',
	props: ['sectionTitle', 'data', 'isValid'],
	methods: {
		validate () {
			this.isValid.name = !!(this.data.name.first && this.data.name.last)
			let iterate = true
			Object.keys(this.isValid).forEach(key => {
				if (key !== 'result') {
					if (!this.isValid[key] && iterate) {
						iterate = false
						this.isValid.result = false
					} else if (this.isValid[key] && iterate) {
						this.isValid.result = true
					}
				}
			})
		}
	},
	beforeMount () {
		this.validate()
	},
	computed: {
		componentTitle () {
			return this.$t(this.sectionTitle)
		}
	}
}
</script>



// WEBPACK FOOTER //
// ../../easytitle24-2.x-common/components/party/person-name.vue